export const PatientInsurancePage: FC = () => <p>insurance</p>;
